import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { statTileSx } from './OpenXAgentStatTiles.styles.ts';
import { responsiveGridSx } from './utils/styles.ts';
import type { OpenXAgentStat } from './utils/types.ts';

type OpenXAgentStatTilesProps = {
  stats: OpenXAgentStat[];
  maxColumns: number;
};

export const OpenXAgentStatTiles = ({ stats, maxColumns }: OpenXAgentStatTilesProps) => (
  <Box component="dl" sx={[{ m: 0 }, responsiveGridSx(maxColumns, 150)]}>
    {stats.map(({ id, icon: Icon, label, value }) => (
      <Box key={id} data-test={`openx-agent-stat-${id}`} sx={statTileSx}>
        <Box
          component="dt"
          sx={{ display: 'flex', alignItems: 'center', gap: 0.75, height: 16, color: 'text.secondary' }}
        >
          <Icon sx={{ fontSize: 18 }} />
          <Typography variant="caption" noWrap>
            {label}
          </Typography>
        </Box>
        <Typography
          component="dd"
          noWrap
          sx={{ m: 0, fontSize: 22, lineHeight: '28px', fontWeight: 700, color: 'text.primary' }}
        >
          {value}
        </Typography>
      </Box>
    ))}
  </Box>
);
